import React, { useEffect, useState } from "react";
import ShiftStream from "../..";

import Table from "./Table";
import Pagination from "../../components/pagination";

import { useAuditLogs } from "./graphql/use-audit-logs";
import { FooterControls, PaginationSlot, FilterSelect } from "../styles";

export const COL_WIDTHS = [
  "12vw",
  "14vw",
  "14vw",
  "10vw",
  "8vw",
  "29vw"
];

const ACTION_OPTIONS = [
  { value: "", label: "All Actions" },
  { value: "scrape", label: "Scrape" },
  { value: "streamAlgo", label: "Stream Algo" },
  { value: "streamCancel", label: "Stream Cancel" },
  { value: "streamClose", label: "Stream Close" },
  { value: "streamReRun", label: "Stream Re-Run" },
  { value: "emailAlgo", label: "Email Algo" },
  { value: "emailCancel", label: "Email Cancel" },
  { value: "emailClose", label: "Email Close" },
  { value: "emailExpire", label: "Email Expire" },
  { value: "emailReRun", label: "Email Re-Run" },
  { value: "emailStop", label: "Email Stop" },
  { value: "warningArchive", label: "Warning Archive" },
];

export const AuditLog = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [actionFilter, setActionFilter] = useState("");

  const { auditLogs, total, totalPages, loading } = useAuditLogs(
    currentPage,
    actionFilter
  );

  useEffect(() => {
    if (!loading && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages, loading]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleActionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setActionFilter(e.target.value);
    setCurrentPage(1);
  };

  return (
    <ShiftStream>
      <div style={{ marginBottom: 12 }}>
        <FilterSelect value={actionFilter} onChange={handleActionChange}>
          {ACTION_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </FilterSelect>
      </div>

      <Table auditLogs={auditLogs} loading={loading} />

      <FooterControls>
        <PaginationSlot>
          <Pagination
            page={currentPage}
            totalPages={totalPages}
            total={total}
            onPageChange={handlePageChange}
            disabled={loading}
          />
        </PaginationSlot>
      </FooterControls>
    </ShiftStream>
  );
};
